import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { Body1, Body2, CollapsableButton, H3 } from 'ensightful-koala-ui';

import { CourseSetUpContainer, HeaderContainer } from 'components/organisms/CourseSetUp';
import TeamSetUp from './TeamSetUp';

const StyledCollapsableButton = styled(CollapsableButton)`
    padding: 1em 0;
    & > button > div {
        font-weight: 600;
        font-size: 2rem;
        line-height: 1.4em;
        letter-spacing: 0.1px;
        color: #212121;
    }
    & > div:last-child {
        padding: 0 1em 0.5em 1em;
    }
    &:not(:last-child):after {
        content: '';
        position: absolute;
        inset: auto 1em 0 1em;
        height: 1px;
        width: calc(100% - 2em);
        border-bottom: 1px solid #e0e0e0;
    }
`;

const StyledBody = styled(Body1)`
    color: #212121;
`;

const CollabasableChildrenContainer = styled.div``;

const ReviewType = styled(Body2)`
    min-width: 45%;
    display: inline-block;
`;

const ReviewContent = styled(Body2)``;
const ReviewRow = styled.div`
    display: flex;
    margin: 0.3em 0;
    & > p {
        font-weight: normal;
    }
`;

const ReviewData = {
    general: [
        { name: 'SCHOOL', title: 'School' },
        { name: 'COURSE_NAME', title: 'Course Name' },
        { name: 'SECTION', title: 'Section' },
        { name: 'FACULTY', title: 'Faculty' },
        { name: 'FIELD_OF_STUDY', title: 'Field of Study' },
        { name: 'SEMESTER', title: 'Semester' },
    ],
    project: [
        { name: 'PROJECT_TITLE', title: 'Project Title' },
        { name: 'START_ON', title: 'Start Date' },
        { name: 'END_ON', title: 'End Date' },
    ],
};

const CourseSetUpReview = ({ ...props }) => {
    const renderReview = (type) => {
        return ReviewData[type].map((item) => {
            let value = props.courseData[props.fieldKeys[item.name]];
            if (item.name === 'START_ON' || item.name === 'END_ON') {
                value = moment(value).format('MMMM D[,] YYYY');
            }
            return (
                <ReviewRow>
                    <ReviewType>{item.title}</ReviewType>
                    <ReviewContent>{value}</ReviewContent>
                </ReviewRow>
            );
        });
    };
    return (
        <CourseSetUpContainer>
            <HeaderContainer style={{ paddingLeft: 14, marginBottom: 32 }}>
                <H3>Review Course</H3>
                <StyledBody>Make sure all information inputted is correct before completing this process.</StyledBody>
            </HeaderContainer>
            <StyledCollapsableButton defaultOpen text={'General Information'}>
                <CollabasableChildrenContainer>{renderReview('general')}</CollabasableChildrenContainer>
            </StyledCollapsableButton>
            <StyledCollapsableButton text={'Project Details'}>
                <CollabasableChildrenContainer>{renderReview('project')}</CollabasableChildrenContainer>
            </StyledCollapsableButton>
            <StyledCollapsableButton text={'Teams'}>
                <CollabasableChildrenContainer>
                    <TeamSetUp review={true} {...props} />
                </CollabasableChildrenContainer>
            </StyledCollapsableButton>
        </CourseSetUpContainer>
    );
};

export default CourseSetUpReview;
